export const SAVE_ONBOARDING_STEP = 'save_onboarding_step';
export const SAVE_ONBOARDING_SUCCESS = 'save_onboarding_success';
export const SAVE_ONBOARDING_FAILED = 'save_onboarding_failed';
export const FETCH_MATCHING_PROFILES = 'fetch_matching_profiles';
export const FETCH_MATCHING_PROFILES_SUCCESS = 'fetch_matching_profiles_success';
export const FETCH_MATCHING_PROFILES_FAILED = 'fetch_matching_profiles_failed';
export const USER_SELECTED_PROFILE = 'user_selected_profile';
export const GET_RATED_INCREMENT_STEP = 'get_rated_increment_step';
export const GET_RATED_DECREMENT_STEP = 'get_rated_decrement_step';
export const GET_RATED_RESET_STEPS = 'get_rated_reset_steps';
